if (!window.wlsnDataInsightBars) {
    window.wlsnDataInsightBars = true;

    const visibleClass = 'is-visible';

    const observer = 'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add(visibleClass);
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.3
            }
        )
        : null;

    const initBars = (root) => {
        root.querySelectorAll('.js-data-insights-bars').forEach(bars => {
            if (observer) {
                observer.observe(bars);
            } else {
                bars.classList.add(visibleClass);
            }
        });
    };

    initBars(document);
    document.addEventListener('shopify:section:load', (event) => initBars(event.target));
}
